import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Flexbox, FlexboxColumn } from '../../../components/action/Flexbox';
import ButtonApi from '../../../components/ButtonApi';
import Logo from '../../../components/Logo/Logo';
import ProjectChip from '../../../components/Review/Projectchip/ProjectChip';
import ProjectDropdown from '../../../components/Review/ProjectDropdown';
import ExpandableCategoryList from '../../../components/Review/ProjectSelector/ExpandableCategoryList';
import TextEditor from '../../../components/Review/TextEditor/TextEditor';
import Tags from '../../../components/Tags/Tags';
import ThemedText from '../../../components/theme/ThemedText';
import { useBackendApi } from '../../../helpers/backendHelper';
import { useGlobalState } from '../../../state/GlobalStateProvider';
import { formatDecimals, formatNumber, trackClairtyEvent } from '../../../utils';

const Write = ({ projectStatus, getProjectStatus, reviewTag }) => {
  const [{ user }] = useGlobalState();
  const { project: routeProject } = useParams();
  const [project, setProject] = useState();
  const [projectData, setProjectData] = useState();
  const [attachments, setAttachments] = useState([]);
  const [reviewContent, setReviewContent] = useState();
  const [refreshData, setRefreshData] = useState(false);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [listOpen, setListOpen] = useState(false);
  const [selectedTag, setSelectedTag] = useState();
  const [heading, setHeading] = useState();
  const backendHelper = useBackendApi();

  function handleProject(project) {
    if (project.disabled) return;
    setProject({ name: project?.name, value: project?.protocol });
    setListOpen(false);
  }

  function handleHeading(event) {
    setHeading(event.target.value);
  }

  async function getProtocolData() {
    try {
      const data = await backendHelper.reviews.getAirdropAndRankingData(project?.value);
      if (project?.value === 'kaito') {
        setProjectData(data?.data?.kaitoData);
      } else if (project?.value === 'layer3') {
        setProjectData(data?.data?.layer3Data);
      } else {
        setProjectData(data?.data?.rankingData);
      }
    } catch (error) {}
  }

  async function handleSubmit() {
    const formData = new FormData();
    formData.append('content', reviewContent);
    formData.append('tags', JSON.stringify([selectedTag?.id]));
    formData.append('header', heading);
    attachments.forEach(file => formData.append('attachments', file));

    if (String(project?.value).startsWith('chain')) {
      formData.append('type', 'chain');
      formData.append('protocol', String(project?.value).split('-')[1]);
    } else {
      formData.append('protocol', project?.value);
    }

    try {
      await backendHelper.reviews.postReview(formData);
      trackClairtyEvent('postreview', String(project?.value).split('-')[1]);
      setRefreshData(true);
      setHeading('');
      getProjectStatus();
      setProject(null);

      setSelectedTag(null);

      alert.success('Review Submitted');
      setTimeout(() => {
        setRefreshData(false);
      }, []);
    } catch (error) {
      alert.error('Something went wrong');
    }
  }

  useEffect(() => {
    if (project) {
      getProtocolData();
    }
  }, [project]);

  useEffect(() => {
    if (projectStatus) {
      setSelectedProjects(projectStatus);
    }
  }, [projectStatus]);

  useEffect(() => {
    trackClairtyEvent('writepagevisited', true);
  }, []);

  useEffect(() => {
    if (routeProject) {
      setProject(JSON.parse(routeProject));
    }
  }, [routeProject]);
  return (
    <FlexboxColumn className='feed_wrapper feed_overflow' gap='2.25rem' justifyContent={'flex-start'}>
      <Flexbox className='feed_wrapper_selector'>
        <ThemedText.H2>i want to write about</ThemedText.H2>
        <ProjectDropdown placeholder='select project' handleClick={() => setListOpen(!listOpen)} selected={project} showCross={false} />
      </Flexbox>
      {listOpen && <ExpandableCategoryList data={selectedProjects} handleClick={handleProject} selected={project} />}

      {project && (
        <>
          <FlexboxColumn justifyContent={'flex-start'} className='feed_wrapper_stats'>
            <Flexbox fw>
              {true ? (
                <ThemedText.H5 weight='medium'> You’re eligible to post for</ThemedText.H5>
              ) : (
                <ThemedText.H5 className='color_red' weight='medium'>
                  {' '}
                  You’re not eligible to post for
                </ThemedText.H5>
              )}

              <ProjectChip project={project?.value} />
            </Flexbox>
            {projectData && (
              <FlexboxColumn fw className='table_container' gap='0'>
                <Flexbox className='table_container__header' fw>
                  <div className='name'>
                    <ThemedText.P weight='semi-bold'>User</ThemedText.P>
                  </div>
                  {Object.keys(projectData || {}).map(item => (
                    <div className='name'>
                      <ThemedText.P weight='semi-bold'>{item}</ThemedText.P>
                    </div>
                  ))}
                </Flexbox>
                <Flexbox className='table_container__row' fw>
                  <div className='name'>
                    <Flexbox fw justifyContent='flex-start' gap='0.5rem'>
                      <Logo src={user?.avatarUrl} width={'1.25rem'} height={'1.25rem'} borderRadius='50%' />
                      <ThemedText.P>{user?.name}</ThemedText.P>
                    </Flexbox>
                  </div>
                  {Object.values(projectData || {}).map(item => (
                    <div className='name'>
                      <ThemedText.P>{formatNumber(formatDecimals(item))}</ThemedText.P>
                    </div>
                  ))}
                  {/* <div className='name'></div>
                <div className='name'>
                  <ThemedText.P>{projectData?.rankingData?.txnCount || 0}</ThemedText.P>
                </div> */}
                </Flexbox>
              </FlexboxColumn>
            )}
          </FlexboxColumn>
        </>
      )}
      <FlexboxColumn justifyContent={'flex-start'} className='feed_wrapper_write' gap='2.5rem'>
        {project && (
          <FlexboxColumn fw>
            <ThemedText.H5>Tags</ThemedText.H5>
            <Tags tags={[...reviewTag?.['all'], ...(reviewTag?.[project?.value] || [])]} onClick={setSelectedTag} />
          </FlexboxColumn>
        )}

        <FlexboxColumn fw>
          <ThemedText.H5>Heading</ThemedText.H5>
          <input className='feed_wrapper_write_heading_input' value={heading} disabled={!project} onChange={handleHeading} />
        </FlexboxColumn>
        <FlexboxColumn fw>
          <ThemedText.H5>Content</ThemedText.H5>
          <TextEditor disabled={!project} handleAttachments={setAttachments} handleContent={setReviewContent} refreshData={refreshData} />
        </FlexboxColumn>
        <ButtonApi className='feed_wrapper_write_post_button' disabled={!reviewContent || !heading || !selectedTag || !project} onClick={handleSubmit}>
          <Logo src={user?.avatarUrl} width={'2.5rem'} height={'2.5rem'} borderRadius='50%' />
          Post as {user?.name}
        </ButtonApi>
      </FlexboxColumn>
    </FlexboxColumn>
  );
};

export default Write;
